import {
  GET_FILE,
  GET_FILE_FAILURE,
  GET_FILE_SUCCESS,
} from "../actions/getFile";
import { INITIAL_FILE_STATE } from "../containers/contexts/SearchContext";

export interface FileState {
  status: number;
  filename: string;
  signedUrl: string;
}

export const fileReducer = (
  state: FileState = INITIAL_FILE_STATE,
  action: {
    type: string;
    status: number;
    filename: string;
    signedUrl: string;
  }
) => {
  const { type, status, filename, signedUrl } = action;
  switch (type) {
    case GET_FILE:
      return {
        ...state,
        ...INITIAL_FILE_STATE,
      };
    case GET_FILE_SUCCESS:
      return {
        ...state,
        status,
        filename,
        signedUrl,
      };
    case GET_FILE_FAILURE:
      return {
        ...state,
        status,
      };
    default:
      return state;
  }
};
